import { render, staticRenderFns } from "./IconArrowLink.vue?vue&type=template&id=11422cb3"
import script from "./IconArrowLink.vue?vue&type=script&lang=js"
export * from "./IconArrowLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports